import React from 'react';
import { Trans, t } from '@lingui/macro';
import { Button, Dialog, Group } from '@economic/taco';
import { useCurrentUser } from '@economic/react-app';
import { Field, Form } from '../../../../../shared/components/Form';

interface Props {
    submit: (values) => void;
    onSubmitted: () => void;
    disableSingleInvoiceControls: boolean;
    selectedOrdersCount: number;
    setNavigateToInvoicesAfterSubmit: (value: boolean) => void;
    formKey: number;
}

const initialData = {
    combined: false,
    showHeading: false,
};

export default function TransferToInvoicingForm({
    submit,
    onSubmitted,
    disableSingleInvoiceControls,
    selectedOrdersCount,
    setNavigateToInvoicesAfterSubmit,
    formKey,
}: Props) {
    const user = useCurrentUser();
    return (
        <Form
            key={formKey}
            initialData={initialData}
            onSubmit={submit}
            messages={{
                success:
                    selectedOrdersCount > 1
                        ? t`Your (${selectedOrdersCount}) orders were succesfully transferred to invoices.`
                        : t`Your order was succesfully transfered to invoice`,
            }}
            onSubmitted={onSubmitted}
            className="mt-8">
            {() => (
                <>
                    <div className="w-1/3 mt-4">
                        <strong>
                            <Trans>Transfer to single invoice</Trans>
                        </strong>
                        <Field.Checkbox
                            fieldClassName="my-2"
                            name="combined"
                            hideLabel
                            text={t`Combine invoices per customer`}
                            disabled={disableSingleInvoiceControls}
                        />
                        <Field.Checkbox name="showHeading" hideLabel text={t`Show header for each order`} />
                    </div>

                    <Dialog.Footer>
                        <Group>
                            {!user.isBasicUser && (
                                <Button
                                    type="submit"
                                    disabled={selectedOrdersCount === 0}
                                    onClick={() => setNavigateToInvoicesAfterSubmit(true)}>
                                    <Trans>Transfer and go to invoice</Trans>
                                </Button>
                            )}
                            <Button
                                appearance="primary"
                                type="submit"
                                disabled={selectedOrdersCount === 0}
                                onClick={() => setNavigateToInvoicesAfterSubmit(false)}>
                                <Trans>Transfer and close</Trans>
                            </Button>
                        </Group>
                    </Dialog.Footer>
                </>
            )}
        </Form>
    );
}
